// Port of api/fuel/app/classes/controller/api/monty/groups/plays.php
import F from 'offline/filter/constants'
import PlaysFilter from 'offline/filter/plays'
import { runFilterEndpoint } from 'offline/api/monty'

export default function(params) {
	return runFilterEndpoint(PlaysFilter, params, F.OWNER_GROUP)
}
